<template>
  <div class="editor-container">
    <asModalDialog
      heading-text="3d esikatselu"
      :show-ok="false"
      :show-cancel="false"
      width="80%"
      min-width="500px"
      ref="previewModal"
      @modal-result-cancel="showGridIfRequired()"
      class="is-marginless"
    >
      <preview3d v-if="editorConfig.viewer !== 'candybox'" :textureWidth=1000 :textureHeight=400 :gblVariable="'Exterior'" :texture="texture" :uri="textureUri"/>

      <candyboxviewer
          v-if="editorConfig.viewer === 'candybox'"
          :glb-path="textureUriCandyBox"
          :textures="candyboxViewerTextures">
      </candyboxviewer>
    </asModalDialog>
    <asModalDialog
        heading-text="Valitse fontti"
        :show-ok="false"
        :show-cancel="false"
        ref="fontModal"
        class="is-marginless"
        width="300px"
        min-width="300px"
      >
      <ul class="fontSelector">
        <li v-for="font in fonts" :key="font">
          <a :style="{'font-family': font}" :class="{'selected': selectedFont==font}" @click="changeFont(font)">{{ font }}</a>
        </li>
      </ul>
      </asModalDialog>
      <asModalDialog
        heading-text="Valitse taustakuva"
        :show-ok="false"
        :show-cancel="false"
        ref="imageModal"
        class="is-marginless"
        width="500px"
        min-width="500px"
      >
        <input id="backgroundImage"
         ref="backgroundImage"
         style="display: none"
         type="file" accept="image/*"
         @change="croppieBg"/>
        <p class="editor-text-content mt-3 mb-5">
          {{ this.$t("message.components.fabricComponent.lataaOma") }}
        </p>
        <a
            class="is-flex is-flex-direction-column is-align-items-start editor-text-icon-modal mb-5"
            @click="addBackground()"
          >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-solid fa-file-arrow-up" aria-hidden="true"></i
                    ></span>
          <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.valitseTiedosto") }}</span>
        </a>
        <div class="container imageSelector">

          <div class="">
            <ul class="horizontal-image-selector-tab" style="margin-bottom: 40px;">
              <li class="image-selector-tab" :class="{ 'is-active': imageSelectorTabActive=='christmas' }" style="margin-right: 30px;">
                <p @click="imageSelectorTabActive='christmas'">Jouluaiheiset taustat</p>
              </li>
              <li class="image-selector-tab" :class="{ 'is-active': imageSelectorTabActive=='default' }">
                <p @click="imageSelectorTabActive='default'">Yleiset tausta-aiheet</p>
              </li>
            </ul>
            <div class="columns is-multiline is-hidden-touch" v-if="imageSelectorTabActive=='christmas'">
              <div class="column is-6" v-for="image in $store.getters.getImagesBank('christmas')" :key="image">
                <img style="max-width:100%;width:200px" crossorigin="anonymous" :src="image.image" @click="selectImage(image)">
              </div>
            </div>
            <div class="columns is-multiline is-hidden-touch" v-if="imageSelectorTabActive=='default'">
              <div class="column is-6" v-for="image in $store.getters.getImagesBank('default')" :key="image">
                <img style="max-width:100%;width:200px" crossorigin="anonymous" :src="image.image" @click="selectImage(image)">
              </div>
            </div>
          </div>

          <div class="columns is-hidden-desktop is-multiline">
            <div class="column is-6 has-text-centered" v-for="image in getImagesBank()" :key="image">
              <img style="max-width:100%;width:200px" crossorigin="anonymous" :src="image.image" @click="selectImage(image)">
            </div>
          </div>


        </div>
      </asModalDialog>

        <!-- Start editor controls icons -->
    <div class="columns is-mobile" v-if="isMultiSided">
      <div class="column is-10 is-offset-1 is-paddingless">
        <div class="tabs is-boxed">
          <ul>
            <li v-for="side in editorConfig.sides" :key="side.name"
                class="tab is-flex-grow-1 is-active"
                :id="side.name + 'Cover'"
                @click="openEditableTab(side.name)"
                :class="{ 'activeEditableTab': activeSideName === side.name }"
            >
              <a class="is-flex is-flex-direction-column is-align-items-center editor-text-icon">
                <span class="editor-action-text">{{ $t("message.components.fabricComponent." + side.name + "Side") }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div class="columns is-fullwidth top-editor-controls is-hidden-touch" id=topEditorControls>
      <div class="column is-1 is-offset-1">
        <a
            class="is-flex is-flex-direction-column is-align-items-center"
            @click="undo"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-undo" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.undoText") }}</span>
        </a>
      </div>
      <div class="column is-1">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="redo"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-redo" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.redoText") }}</span>
        </a>
      </div>
      <div class="column is-1">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="initialCanvas"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-trash" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.clearAllText") }}</span>
        </a>
      </div>
      <div class="column is-1" v-if="editorConfig.has_grid">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="flipGrid"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-border-style" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.grid") }}</span>
        </a>
      </div>
      <div class="column is-1">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="open3DPreview()"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-regular fa-eye d-color" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.d3Esikatse") }}</span>
        </a>
      </div>
      <div class="column is-1 is-offset-3">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="openHelpModal()"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fa-solid fa-circle-question" aria-hidden="true"></i
                    ></span>
        </a>
      </div>       
      <div class="column is-1" v-if="editorConfig.has_turtle_logo">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="openTurtleModal()"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fa-solid fa-recycle" aria-hidden="true"></i
                    ></span>
        </a>
      </div>
    </div>
    <div class="columns is-fullwidth top-editor-controls is-hidden-desktop is-mobile is-multiline" id=topEditorControls>
      <div class="column is-6">
        <a
            class="is-flex is-flex-direction-column is-align-items-center"
            @click="undo"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-undo" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.undoText") }}</span>
        </a>
      </div>
      <div class="column is-6">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="redo"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-redo" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.redoText") }}</span>
        </a>
      </div>
      <div class="column is-6">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="initialCanvas"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-trash" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.clearAllText") }}</span>
        </a>
      </div>
      <div class="column is-6">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="open3DPreview()"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fas fa-regular fa-eye d-color" aria-hidden="true"></i
                    ></span>
          <span class="top-editor-text has-text-centered">{{ this.$t("message.components.fabricComponent.d3Esikatse") }}</span>
        </a>
      </div>
      <div class="column is-6">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="openTurtleModal()"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fa-solid fa-recycle" aria-hidden="true"></i
                    ></span>
        </a>
      </div>         
      <div class="column is-6">
        <a
            class="is-flex is-flex-direction-column is-align-items-center "
            @click="openHelpModal()"
        >
                    <span class="icon is-small mr-0"
                    ><i class="fa-solid fa-circle-question" aria-hidden="true"></i
                    ></span>
        </a>
      </div>      
    </div>
    <!-- Single-canvas products (Cup) -->
    <div class="columns is-mobile" ref="parentEditorWrapper" id="parentEditorWrapper" :style="editorHeightProperty" v-if="!isMultiSided">
      <div class="column is-10 is-offset-1 editor-wrapper pb-0" ref="editorwrapper" :style="editorWrapperStyle">
        <canvas id="editorcanvas" ref="can"></canvas>
      </div>
    </div>

    <!-- Multi-sided products (CandyBox) -->
    <template v-if="isMultiSided">
      <div v-for="side in editorConfig.sides" :key="side.name"
           class="columns is-mobile"
           :style="sideWrapperStyle(side)"
           v-show="activeSideName === side.name"
      >
        <div class="column is-10 is-offset-1 editor-wrapper pb-0" ref="editorwrapper">
          <canvas :id="side.canvasId" :ref="side.ref"></canvas>
        </div>
      </div>
    </template>

    <!-- Start editor controls icons -->
    <div class="columns is-mobile">
      <div class="column is-10 is-offset-1 is-paddingless">
        <div class="tabs is-boxed">
          <ul>
            <li
                class="tab is-flex-grow-1 is-active" id="kuvaContent"
                @click="openTab('kuvaContent', 'kuva-content')"
            >
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-regular fa-file-image" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.backgroundText") }}</span>
              </a>
            </li>
            <li
                class="tab is-flex-grow-1" id="tekstiContent"
                @click="openTab('tekstiContent', 'teksti-content')"
            >
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-font" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.textText") }}</span>
              </a>
            </li>
            <li
                class="tab is-flex-grow-1" id="logoContent"
                @click="openTab('logoContent', 'logo-content')"
            >
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-solid fa-star" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.logoText") }}</span>
              </a>
            </li>
            <li
                class="tab is-flex-grow-1" id="shapesContent"
                @click="openTab('shapesContent', 'shapes-content')"
            >
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-regular fa-circle" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.shapesText") }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column is-10 is-offset-1">
        <!-- Start editor Controls Content -->
        <div class="editor-action-content py-5 border-bottom">
          <!-- Text content -->
          <div
              id="teksti-content"
              class="content-tab is-align-items-center"
              style="display: none"
          >
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <a
                  class="is-flex is-flex-direction-column editor-text-icon is-align-items-center"
                  @click="addTextBox()"
              >
                <span class="icon is-small mr-0"
                  ><i class="fas fa-solid fa-plus" aria-hidden="true"></i
                ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.addNewText") }}</span>
              </a>
            </div>

            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="openFontModal"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-font" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.fontText") }}</span>
              </a>
            </div>

            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <div class="bg-color-picker-wrapper" v-if=showFontColorPicker>
                <ColorPicker
                     :color="fontColor"
                     @color-change="updateFontColor"
                     :visible-formats="['hsl']"
                     alpha-channel="hide"
                   >
                </ColorPicker>
                <div class="has-text-centered">
                    <label for="fontCyan">C:</label>
                    <input type="range" v-model="fontColorCMYK.cyan" id="fontCyan" min="0" max="100" step="1">
                    <span>{{ fontColorCMYK.cyan }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="fontMagenta">M:</label>
                    <input type="range" v-model="fontColorCMYK.magenta" id="fontMagenta" min="0" max="100" step="1">
                    <span>{{ fontColorCMYK.magenta }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="fontYellow">Y:</label>
                    <input type="range" v-model="fontColorCMYK.yellow" id="fontYellow" min="0" max="100" step="1">
                    <span>{{ fontColorCMYK.yellow }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="fontBlack">K:</label>
                    <input type="range" v-model="fontColorCMYK.black" id="fontBlack" min="0" max="100" step="1">
                    <span>{{ fontColorCMYK.black }}</span>
                </div>
                 <ColorPickerFooter
                  :bgColor="fontColor || '#44BDC7'"
                  @cp-confirmButton="changeFontColor()"
                  @cp-cancelButton="showFontColorPicker=false"
                 />
               </div>
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="showFontColorPicker = !showFontColorPicker"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-palette" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.colorText") }}</span>
              </a>
            </div>
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="deleteItem()"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-trash" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.removeText") }}</span>
              </a>
            </div>
          </div>

          <!-- Logo content -->
          <div
              id="logo-content"
              class="content-tab"
              style="display: none"
          >
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <input ref="imageUpload" id="filereader" style="display: none" type="file" accept="image/*"
                @change="croppieLogo"/>
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="addLogo()"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-solid fa-file-arrow-up" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.selectImageText") }}</span>
              </a>
            </div>
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="deleteItem()"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-trash" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.removeText") }}</span>
              </a>
            </div>
          </div>

          <!-- Shapes content -->
          <div
              id="shapes-content"
              class="content-tab"
              style="display: none"
          >

            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <div class="bg-color-picker-wrapper" v-if=showShapesColorPicker>
                <ColorPicker
                     :color="fontColor"
                     @color-change="updateShapeColor"
                     :visible-formats="['hsl']"
                     alpha-channel="hide"
                   >
                </ColorPicker>
                <div class="has-text-centered">
                    <label for="shapeCyan">C:</label>
                    <input type="range" v-model="shapeColorCMYK.cyan" id="shapeCyan" min="0" max="100" step="1">
                    <span>{{ shapeColorCMYK.cyan }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="shapeMagenta">M:</label>
                    <input type="range" v-model="shapeColorCMYK.magenta" id="shapeMagenta" min="0" max="100" step="1">
                    <span>{{ shapeColorCMYK.magenta }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="shapeYellow">Y:</label>
                    <input type="range" v-model="shapeColorCMYK.yellow" id="shapeYellow" min="0" max="100" step="1">
                    <span>{{ shapeColorCMYK.yellow }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="shapeBlack">K:</label>
                    <input type="range" v-model="shapeColorCMYK.black" id="shapeBlack" min="0" max="100" step="1">
                    <span>{{ shapeColorCMYK.black }}</span>
                </div>
                 <ColorPickerFooter
                  :bgColor="shapeColor || '#44BDC7'"
                  @cp-confirmButton="changeShapesColor()"
                  @cp-cancelButton="showShapesColorPicker=false"
                 />
               </div>
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="showShapesColorPicker = !showShapesColorPicker"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-palette" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.colorText") }}</span>
              </a>
            </div>

            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <a
                  class="is-flex is-flex-direction-column editor-text-icon is-align-items-center"
                  @click="addCircle()"
              >
                <span class="icon is-small mr-0"
                  ><i class="fas fa-regular fa-circle" aria-hidden="true"></i
                ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.addCircle") }}</span>
              </a>
            </div>

            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
              <a
                  class="is-flex is-flex-direction-column editor-text-icon is-align-items-center"
                  @click="addRectangle()"
              >
                <span class="icon is-small mr-0"
                  ><i class="fas fa-regular fa-square" aria-hidden="true"></i
                ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.addRectangle") }}</span>
              </a>
            </div>

          </div>

          <!-- Kuva content -->
          <div
              id="kuva-content"
              class="content-tab default-active"
          >
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center is-hidden-touch">
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="openBankImageModal()"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-solid fa-file-arrow-up" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.vaihdaText") }}</span>
              </a>
            </div>
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center is-hidden-touch">
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="showBackground=true"
                  :class="{'icon-disabled': !hasBackgroundPicture}"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-rotate" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text"
                      :class="{'text-disabled': !hasBackgroundPicture}"
                >{{ this.$t("message.components.fabricComponent.kierraText") }}</span>
              </a>
            </div>
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center is-hidden-touch">
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="showBackground=true"
                  :class="{'icon-disabled': !hasBackgroundPicture}"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-arrows-alt" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text"
                      :class="{'text-disabled': !hasBackgroundPicture}"
                >{{ this.$t("message.components.fabricComponent.kohdistaText") }}</span>
              </a>
            </div>
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center is-hidden-touch">
              <div class="bg-color-picker-wrapper" v-if=showBgColorPicker>
                <ColorPicker
                     :color="backgroundColor"
                     @color-change="updateBgColor"
                     :visible-formats="['hsl']"
                     alpha-channel="hide"
                   >
                </ColorPicker>
                <div class="has-text-centered">
                    <label for="bgColorDesktopcyan">C:</label>
                    <input type="range" v-model="backgroundColorCMYK.cyan" id="bgColorDesktopcyan" min="0" max="100" step="1">
                    <span>{{ backgroundColorCMYK.cyan }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="bgColorDesktopmagenta">M:</label>
                    <input type="range" v-model="backgroundColorCMYK.magenta" id="bgColorDesktopmagenta" min="0" max="100" step="1">
                    <span>{{ backgroundColorCMYK.magenta }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="bgColorDesktopyellow">Y:</label>
                    <input type="range" v-model="backgroundColorCMYK.yellow" id="bgColorDesktopyellow" min="0" max="100" step="1">
                    <span>{{ backgroundColorCMYK.yellow }}</span>
                </div>
                <div class="has-text-centered">
                    <label for="bgColorDesktopblack">K:</label>
                    <input type="range" v-model="backgroundColorCMYK.black" id="bgColorDesktopblack" min="0" max="100" step="1">
                    <span>{{ backgroundColorCMYK.black }}</span>
                </div>
                <ColorPickerFooter
                  :bgColor="backgroundColor || '#44BDC7'"
                  @cp-confirmButton="changeBackgroundColor()"
                  @cp-cancelButton="showBgColorPicker=false"
                />
                <label class="checkbox">
                  {{ this.$t("message.components.fabricComponent.applyBgColorToAllSides") }}
                  <input type="checkbox" v-model="applyBgColorToAllSides">
               </label>
              </div>
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  :class="{'icon-disabled': hasBackgroundPicture}"
                  @click="bgColorIconClick"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-palette" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text"
                      :class="{'text-disabled': hasBackgroundPicture}"
                >{{ this.$t("message.components.fabricComponent.colorText") }}</span>
              </a>
            </div>
            <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center is-hidden-touch">
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  @click="deleteBackgroundPicture()"
                  :class="{'icon-disabled': !hasBackgroundPicture}"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-trash" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text"
                      :class="{'text-disabled': !hasBackgroundPicture}"
                >{{ this.$t("message.components.fabricComponent.deleteBackgroundPicture") }}</span>
              </a>
            </div>
            <div class="is-hidden-desktop container">
              <div class="columns is-mobile is-multiline">
                <div class="column is-6">
                  <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
                     <div class="bg-color-picker-wrapper" v-if=showBgColorPicker>
                       <ColorPicker
                           :color="backgroundColor"
                           @color-change="updateBgColor"
                           :visible-formats="['hsl']"
                           alpha-channel="hide"
                         >
                      </ColorPicker>
                      <div class="has-text-centered">
                          <label for="bgColorMobileCyan">C:</label>
                          <input type="range" v-model="backgroundColorCMYK.cyan" id="bgColorMobileCyan" min="0" max="100" step="1">
                          <span>{{ backgroundColorCMYK.cyan }}</span>
                      </div>
                      <div class="has-text-centered">
                          <label for="bgColorMobileMagenta">M:</label>
                          <input type="range" v-model="backgroundColorCMYK.magenta" id="bgColorMobileMagenta" min="0" max="100" step="1">
                          <span>{{ backgroundColorCMYK.magenta }}</span>
                      </div>
                      <div class="has-text-centered">
                          <label for="bgColorMobileYellow">Y:</label>
                          <input type="range" v-model="backgroundColorCMYK.yellow" id="bgColorMobileYellow" min="0" max="100" step="1">
                          <span>{{ backgroundColorCMYK.yellow }}</span>
                      </div>
                      <div class="has-text-centered">
                          <label for="bgColorMobileBlack">K:</label>
                          <input type="range" v-model="backgroundColorCMYK.black" id="bgColorMobileBlack" min="0" max="100" step="1">
                          <span>{{ backgroundColorCMYK.black }}</span>
                      </div>
                        <ColorPickerFooter
                          :bgColor="backgroundColor || '#44BDC7'"
                          @cp-confirmButton="changeBackgroundColor()"
                          @cp-cancelButton="showBgColorPicker=false"
                        />
                     </div>
                    <a
                        class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                        @click="openBankImageModal()"
                    >
                                <span class="icon is-small mr-0"
                                ><i class="fas fa-solid fa-file-arrow-up" aria-hidden="true"></i
                                ></span>
                      <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.vaihdaText") }}</span>
                    </a>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
                    <a
                        class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                        @click="showBackground=true"
                        :class="{'icon-disabled': !hasBackgroundPicture}"
                    >
                                <span class="icon is-small mr-0"
                                ><i class="fas fa-rotate" aria-hidden="true"></i
                                ></span>
                      <span class="editor-action-text"
                            :class="{'text-disabled': !hasBackgroundPicture}"
                      >{{ this.$t("message.components.fabricComponent.kierraText") }}</span>
                    </a>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
                    <a
                        class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                        @click="showBackground=true"
                        :class="{'icon-disabled': !hasBackgroundPicture}"
                    >
                                <span class="icon is-small mr-0"
                                ><i class="fas fa-arrows-alt" aria-hidden="true"></i
                                ></span>
                      <span class="editor-action-text"
                            :class="{'text-disabled': !hasBackgroundPicture}"
                      >{{ this.$t("message.components.fabricComponent.kohdistaText") }}</span>
                    </a>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
                  <a
                      class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                      :class="{'icon-disabled': hasBackgroundPicture}"
                      @click="bgColorIconClick"
                  >
                              <span class="icon is-small mr-0"
                              ><i class="fas fa-palette" aria-hidden="true"></i
                              ></span>
                    <span class="editor-action-text"
                          :class="{'text-disabled': hasBackgroundPicture}"
                    >{{ this.$t("message.components.fabricComponent.colorText") }}</span>
                  </a>
                 </div>
                </div>
                <div class="column is-6">
                  <div class="is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-center">
                    <a
                        class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                        @click="deleteBackgroundPicture()"
                        :class="{'icon-disabled': !hasBackgroundPicture}"
                    >
                                <span class="icon is-small mr-0"
                                ><i class="fas fa-trash" aria-hidden="true"></i
                                ></span>
                      <span class="editor-action-text"
                            :class="{'text-disabled': !hasBackgroundPicture}"
                      >{{ this.$t("message.components.fabricComponent.deleteBackgroundPicture") }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- End editor control content -->
    <div style="display: none">
      <img :src="croppedLogo">
    </div>
    <div>
      <pop-modal :value="showLogo" @close="cancelCropModal">
        <vue-croppie
          class="croppie"
          ref="croppieRefLogo"
          :enableOrientation="true"
          :enableExif="true"
          :showZoomer="true"
          :enableResize="true"
          :maxZoom="2.4"
          @update="changeCropperLogo"
          :boundary="logoCroppieBoundary"
          :viewport="logoCroppieViewport"
        >
        </vue-croppie>
        <template v-slot:footer>
          <a
            class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
            @click="rotateLogo"
          >
                      <span class="icon is-small mr-0"
                      ><i class="fas fa-rotate" aria-hidden="true"></i
                      ></span>
            <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.kierraText") }}</span>
          </a>
          <div class="column is-flex is-flex-wrap-wrap is-justify-content-space-between" style="gap: 0.5rem;">
            <button class="pyroll-button purple-bg font-white" @click="saveCroppedImageLogo">{{ this.$t("message.components.fabricComponent.saveText") }}</button>
            <button class="pyroll-button purple-bg font-white" @click="cancelCropModal">{{ this.$t("message.components.fabricComponent.cancelText") }}</button>
          </div>
        </template>
      </pop-modal>
    </div>
    <div>
      <pop-modal :value="true" :vanish="!showBackground" @close="cancelCropModalBg" v-if="canvasHeight">
        <div class="container">
          <div class="columns mb-0 pb-0">
            <div class="column is-12 mb-0 pb-0" style="position: relative;">
              <vue-croppie
                    class="croppie"
                    ref="croppieRefBg"
                    :enableOrientation="true"
                    :enableExif="true"
                    :showZoomer="true"
                    :enableResize="false"
                    :maxZoom="2.4"
                    :minZoom="0.1"
                    @update="changeCropperBg"
                    :boundary="bgCroppieBoundary"
                    :viewport="bgCroppieViewport"
                >
              </vue-croppie>
              <div v-if="croppieBleedOverlayStyle" :style="croppieBleedOverlayStyle" class="bleed-overlay"></div>
              <p v-if="bleedConfig" class="has-text-centered bleed-label">
                <small>Punaisen katkoviivan ulkopuolella oleva alue on {{ bleedConfig.bleed_mm }} mm leikkausvara</small>
              </p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12 is-flex is-justify-content-end has-text-centered">
              <a
                  class="is-flex is-flex-direction-column is-align-items-center editor-text-icon"
                  style="width: 100%;"
                  @click="rotateBg"
              >
                          <span class="icon is-small mr-0"
                          ><i class="fas fa-rotate" aria-hidden="true"></i
                          ></span>
                <span class="editor-action-text">{{ this.$t("message.components.fabricComponent.kierraText") }}</span>
              </a>
            </div>
          </div>
        </div>

        <template v-slot:footer>
          <div class="column is-flex is-flex-wrap-wrap is-justify-content-space-between" style="gap: 0.5rem;">
            <button class="pyroll-button purple-bg font-white" @click="saveCroppedImageBg">{{ this.$t("message.components.fabricComponent.saveText") }}</button>
            <button class="pyroll-button purple-bg font-white" @click="cancelCropModalBg">{{ this.$t("message.components.fabricComponent.cancelText") }}</button>
          </div>
        </template>
      </pop-modal>
    </div>
  </div>
  <EditorHelpModal ref="editorHelpModal"/>
</template>

<script>
import fabric from '@/components/_fabric'
import VueCroppieComponent from "@/components/VueCroppieComponent"
import Modal from "@/components/Modal"
import preview3d from "@/3d/preview3d"
import asModalDialog from "@/helpers/asModalDialog"
import cartMixin from "@/mixins/cartMixin"
import colorPickerMixin from "@/mixins/colorPickerMixin"
import EditorHelpModal from "@/modals/EditorHelpModal"
import {ColorPicker} from 'vue-accessible-color-picker'
import ColorPickerFooter from "@/components/ColorPickerFooter"
import {mapGetters, mapMutations} from "vuex";
import candyboxviewer from "@/3d/CandyBoxViewer"
import turtle from '@/assets/img/turtle.png'
import convert from 'color-convert';

export default {
  components: {
    "vue-croppie": VueCroppieComponent,
    "pop-modal": Modal,
    "preview3d": preview3d,
    "candyboxviewer": candyboxviewer,
    "asModalDialog": asModalDialog,
    ColorPicker,
    EditorHelpModal,
    ColorPickerFooter,
  },
  mixins: [cartMixin, colorPickerMixin],
  data() {
    return {
      fonts: [
        "abrilfatface",
        "dancingscript",
        "domine",
        "josefinsans",
        "oswald",
        "robotoslab",
        "quicksand",
        "ubuntu",
        "specialelite"
      ],
      selectedFont: "abrilfatface",
      canvasInitColor: 'white',
      canvas: null,
      canRef: null,

      // Data-driven multi-canvas support
      sideCanvases: {},       // { sideName: fabricCanvasInstance }
      sideDataUrls: {},       // { sideName: dataUrl }
      sideCroppedBgs: {},     // { sideName: croppedBgBase64 }
      activeSideName: '',     // current active side name
      multiSideScaleFactor: 0.53,
      applyBgColorToAllSides: false,

      rect: null,
      img: '',
      textBox: null,
      circle: null,
      rectangle: null,
      colors: null,
      showLogo: false,
      croppieImageLogo: '',
      croppedLogo: null,
      isRedoing: false,
      redoUndoHistory: [],
      dataUrl: '',
      showBackground: false,
      croppedBg: '',
      croppedBgMaxZoom: 2.5,
      croppedBgMinZoom: 0.1,
      croppieDataBg: {},
      scale: 1,
      canvasHeight: 0,
      canvasWidth: 0,
      scaleFactor: 0.83,
      showBgColorPicker: false,
      showFontColorPicker: false,
      showShapesColorPicker: false,
      canvasGridVisible: false,
      backgroundColorCMYK: {
        cyan: 0,
        magenta: 0,
        yellow: 0,
        black: 0
      },
      fontColorCMYK: {
        cyan: 0,
        magenta: 0,
        yellow: 0,
        black: 100
      },
      shapeColorCMYK: {
        cyan: 0,
        magenta: 0,
        yellow: 0,
        black: 100
      },
      imageSelectorTabActive: 'christmas'
    }
  },
  props: ['product'],
  mounted() {
    let productConf = this.product['convert_conf']
    this.canvasWidth = productConf['width']
    this.canvasHeight = productConf['height']

    if (this.isMultiSided) {
      // Data-driven multi-canvas init
      const sides = this.editorConfig.sides
      const bleedMm = this.editorConfig.bleed_mm || 0
      this.activeSideName = sides[0].name

      // Set initial canvasWidth/canvasHeight for the first side (including bleed)
      const firstSide = sides[0]
      if (bleedMm && firstSide.width_mm && firstSide.height_mm) {
        const bx = Math.round(bleedMm * firstSide.width / firstSide.width_mm)
        const by = Math.round(bleedMm * firstSide.height / firstSide.height_mm)
        this.canvasWidth = firstSide.width + bx * 2
        this.canvasHeight = firstSide.height + by * 2
      }

      for (const side of sides) {
        // Compute per-side bleed in pixels
        let bleedPxX = 0, bleedPxY = 0
        if (bleedMm && side.width_mm && side.height_mm) {
          bleedPxX = Math.round(bleedMm * side.width / side.width_mm)
          bleedPxY = Math.round(bleedMm * side.height / side.height_mm)
        }
        const totalW = side.width + bleedPxX * 2
        const totalH = side.height + bleedPxY * 2

        const refEl = this.$refs[side.ref]
        const canvasEl = Array.isArray(refEl) ? refEl[0] : refEl
        const fabricCanvas = new fabric.Canvas(canvasEl)
        // that -1 is to fix a border issue in the editor.
        fabricCanvas.setDimensions({ width: totalW - 1, height: totalH })
        fabricCanvas.backgroundColor = this.canvasInitColor
        fabricCanvas.stateful = true

        // Draw bleed guide rectangle (non-exportable dashed border)
        if (bleedPxX > 0 || bleedPxY > 0) {
          const guide = new fabric.Rect({
            left: bleedPxX,
            top: bleedPxY,
            width: side.width,
            height: side.height,
            fill: 'transparent',
            stroke: 'rgba(255, 0, 0, 0.5)',
            strokeDashArray: [6, 4],
            strokeWidth: 1,
            selectable: false,
            evented: false,
            excludeFromExport: true,
            id: 'bleedGuide',
          })
          fabricCanvas.add(guide)
        }

        fabricCanvas.renderAll()
        fabricCanvas._historySaveAction()
        fabricCanvas.on('object:moving', this.moveHandler)
        fabricCanvas.on('object:rotating', this.rotating)
        fabricCanvas.on('object:scaling', this.scaling)
        fabricCanvas.on('object:modified', (e) => this.getDataUrlForSide(e, side.name))
        fabricCanvas.on('mouse:down', this.switchTab)

        this.sideCanvases[side.name] = fabricCanvas
        this.sideDataUrls[side.name] = ''
        this.sideCroppedBgs[side.name] = ''
      }

      this.canvas = this.sideCanvases[sides[0].name]
      this.scalefactor = this.multiSideScaleFactor

    } else {
      // Single-canvas product (Cup, etc.)
      this.canRef = this.$refs.can
      this.canvas = new fabric.Canvas(this.canRef)
      // that -1 is to fix a border issue in the editor.
      this.canvas.setDimensions({width: this.canvasWidth - 1, height: this.canvasHeight})
      if (this.selectedProduct['fabric_metadata'])
        this.canvas._loadHistory(this.selectedProduct['fabric_metadata'])
      this.canvas.stateful = true
      this.canvas.renderAll()
      this.canvas._historySaveAction()
      this.canvas.on('object:moving', this.moveHandler)
      this.canvas.on('object:rotating', this.rotating)
      this.canvas.on('object:scaling', this.scaling)
      this.canvas.on('object:modified', this.getDataUrl)
      this.canvas.on('mouse:down', this.switchTab)
    }

    this.changeBackgroundColor() // init white background color

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      this.$nextTick(() => this.onResize())
      this.addTurtleLogo()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapGetters([
      'getImagesBank'
    ]),
    ...mapMutations([
      'setNotificationActiveState'
    ]),
    onResize() {
      if (this.$refs.parentEditorWrapper) {
        let screenWidth = window.screen.width
        let width
        let height = this.$refs.parentEditorWrapper.clientHeight
        if (screenWidth < 1024) {
          width = screenWidth
          document.getElementById('parentEditorWrapper').style.maxWidth = `${width}px`
        }
        else {
          document.getElementById('parentEditorWrapper').style.maxWidth = document.getElementById('topEditorControls').style.width
          width = this.$refs.parentEditorWrapper.clientWidth
        }
        this.scale = (width * this.scaleFactor) / this.canvasWidth
        this.editorHeight = height / this.canvasHeight
        document.getElementById('editorcanvas').style.display = 'block'
      }
    },
    initialCanvas() {
      this.canvas.clear()
      this.croppedBg = ''
      this.canvas.backgroundColor = this.canvasInitColor
      this.canvas.renderAll()
      this.addTurtleLogo()
      this.canvas.setActiveObject(this.canvas.item(0))
    },
    undo() {
      this.canvas.undo()
    },
    addBackground() {
      this.$refs.backgroundImage.click()
    },
    bgColorIconClick() {
      if (this.isMultiSided) {
        if (this.sideCroppedBgs[this.activeSideName] != '') {
          return
        }
      } else {
        if (this.croppedBg) return;
      }
      this.showBgColorPicker = !this.showBgColorPicker
    },
    redo() {
      this.canvas.redo()
    },
    getDataUrl(e) {
      this.switchTab(e)
      this.dataUrl = this.canvas.toDataURL()
      this.selectedProduct['fabric_metadata'] = this.canvas._historyNext()
    },
    getDataUrlForSide(e, sideName) {
      this.switchTab(e)
      const canvas = this.sideCanvases[sideName]
      const guide = canvas.getObjects().find(o => o.id === 'bleedGuide')
      if (guide) guide.set('visible', false)
      canvas.renderAll()
      this.sideDataUrls[sideName] = canvas.toDataURL()
      if (guide) guide.set('visible', true)
      canvas.renderAll()
    },
    _hideBleedGuides() {
      for (const [, canvas] of Object.entries(this.sideCanvases)) {
        canvas.getObjects().forEach(obj => {
          if (obj.id === 'bleedGuide') obj.set('visible', false)
        })
        canvas.renderAll()
      }
    },
    _showBleedGuides() {
      for (const [, canvas] of Object.entries(this.sideCanvases)) {
        canvas.getObjects().forEach(obj => {
          if (obj.id === 'bleedGuide') obj.set('visible', true)
        })
        canvas.renderAll()
      }
    },
    getAllSideDataUrls() {
      this._hideBleedGuides()
      const result = {}
      for (const side of this.editorConfig.sides) {
        const canvasEl = document.getElementById(side.canvasId)
        result[side.name] = canvasEl.toDataURL()
      }
      this._showBleedGuides()
      return result
    },
    loadAndUse(font) {
      let FontFaceObserver = require('fontfaceobserver')
      let self = this
      let myfont = new FontFaceObserver(font)
      myfont.load()
          .then(function () {
            // when font is loaded, use it.
            self.canvas.getActiveObject().set("fontFamily", font)
            self.canvas.requestRenderAll()
          }).catch(function (e) {
      });
    },
    changeFont(font) {
      this.selectedFont = font
      this.$refs.fontModal.answerNAY()
      const activeObject = this.canvas.getActiveObject()
      if (activeObject && activeObject.type === 'i-text') {
        this.loadAndUse(this.selectedFont)
      }
    },
    switchTab(e) {
      const activeObject = this.canvas.getActiveObject()
      let type = ''
      if (activeObject) {
        if (activeObject instanceof fabric.Circle || activeObject instanceof fabric.Rect) {
          type = 'shape'
        } else {
          type = activeObject.type
        }
      }
      switch (type) {
        case 'i-text':
          this.openTab('tekstiContent', 'teksti-content')
          break
        case 'image':
          this.openTab('logoContent', 'logo-content')
          break
        case 'shape':
          this.openTab('shapesContent', 'shapes-content')
          break
        default:
          this.openTab('kuvaContent', 'kuva-content')
      }
    },
    changeFontColor() {
      const activeObject = this.canvas.getActiveObject()
      if (activeObject && activeObject.type === 'i-text') {
        activeObject.set("fill", this.fontColor)
        this.canvas.requestRenderAll()
      }
      this.showFontColorPicker = false
    },
    changeShapesColor() {
      const activeObject = this.canvas.getActiveObject()
      if (activeObject && (activeObject instanceof fabric.Circle || activeObject instanceof fabric.Rect)) {
        activeObject.set("stroke", this.shapeColor)
        this.canvas.requestRenderAll()
      }
      this.showShapesColorPicker = false
    },
    changeBackgroundColor() {
      if (this.isMultiSided && this.applyBgColorToAllSides) {
        for (const [sideName, sideCanvas] of Object.entries(this.sideCanvases)) {
          sideCanvas.backgroundColor = this.backgroundColor
          sideCanvas.renderAll()
          sideCanvas._historySaveAction()
          const guide = sideCanvas.getObjects().find(o => o.id === 'bleedGuide')
          if (guide) guide.set('visible', false)
          sideCanvas.renderAll()
          this.sideDataUrls[sideName] = sideCanvas.toDataURL()
          if (guide) guide.set('visible', true)
          sideCanvas.renderAll()
        }
      } else {
        this.canvas.backgroundColor = this.backgroundColor
      }
      this.canvas.renderAll()
      this.canvas._historySaveAction()
      this.showBgColorPicker = false
    },
    updateBgColor (eventData) {
      let { h, s, l } = this.parseHSL(eventData.cssColor)
      let cmyk = this.hslToCmyk(h, s, l)
      this.backgroundColorCMYK.cyan = cmyk.cyan
      this.backgroundColorCMYK.black = cmyk.black
      this.backgroundColorCMYK.magenta = cmyk.magenta
      this.backgroundColorCMYK.yellow = cmyk.yellow
    },
    updateFontColor (eventData) {
      let { h, s, l } = this.parseHSL(eventData.cssColor)
      let cmyk = this.hslToCmyk(h, s, l)
      this.fontColorCMYK .cyan = cmyk.cyan
      this.fontColorCMYK.black = cmyk.black
      this.fontColorCMYK.magenta = cmyk.magenta
      this.fontColorCMYK.yellow = cmyk.yellow
    },
    updateShapeColor (eventData) {
      let { h, s, l } = this.parseHSL(eventData.cssColor)
      let cmyk = this.hslToCmyk(h, s, l)
      this.shapeColorCMYK.cyan = cmyk.cyan
      this.shapeColorCMYK.black = cmyk.black
      this.shapeColorCMYK.magenta = cmyk.magenta
      this.shapeColorCMYK.yellow = cmyk.yellow
    },
    showGridIfRequired() {
      if (this.canvasGridVisible)
        this.addGrid()
    },
    flipGrid(changeStatus=true) {
      if (!this.canvasGridVisible)
        this.addGrid()
      else
        this.removeGrid()
      if (changeStatus)
        this.canvasGridVisible = !this.canvasGridVisible
    },
    addGrid() {
      const cupsGrids = {
        1: 'cup-grid-6oz.png',
        2: 'cup-grid-8oz.png',
        3: 'cup-grid-12oz.png',
        4: 'cup-grid-16oz.png',
        5: 'cup-grid-20oz.png'
      }
      let self = this
      // Just to get scaling values
      fabric.Image.fromURL(`${process.env.BASE_URL}3d/${cupsGrids[self.product.id]}`, (img) => {
        this.canvas.setOverlayImage(
         `${process.env.BASE_URL}3d/${cupsGrids[self.product.id]}`,
          this.canvas.renderAll.bind(this.canvas),
          {
            scaleX: self.canvas.getWidth() / img.width,
            scaleY: self.canvas.getHeight() / img.height,
            objectCaching: false,
            originX: 'left',
            originY: 'top',
            opacity: 1,
          }
        )
      })
    },
    removeGrid() {
      this.canvas.setOverlayImage(null, this.canvas.renderAll.bind(this.canvas))
    },
    addTextBox() {
      let FontFaceObserver = require('fontfaceobserver')
      let self = this
      let myfont = new FontFaceObserver(this.selectedFont)
      myfont.load()
        .then(function () {
          // when font is loaded, use it.
          self.textBox = new fabric.IText('Text', {
            width: 400,
            textAlign: 'center',
            originX: 'center',
            originY: 'center',
            fontSize: '60',
            fill: self.fontColor,
            fontFamily: self.selectedFont,
            top: self.canvasHeight / 2,
            left: self.canvasWidth / 2,
            borderColor: "#23B6BB",
            borderScaleFactor: 3,
            borderOpacityWhenMoving: 1,
            cornerColor: "#D9C731",
            cornerStrokeColor: "#D9C731",
            transparentCorners: false,
            cornerStyle: 'circle',
            cornerSize: 20,
          })
          self.canvas.add(self.textBox)
          let turtle = self.canvas.item(0)
          turtle.bringToFront()
        }).catch(function (e) {
        console.log(e)
      });
    },
    addLogo() {
      this.$refs.imageUpload.click()
    },
    deleteItem() {
      this.canvas.getActiveObjects().forEach((obj) => {
        if (obj.id != 'turtle') {
          this.canvas.remove(obj)
        }
      })
      this.canvas.discardActiveObject().renderAll()
    },
    cancelCropModal() {
      this.croppedLogo = null
      this.showLogo = false
      this.croppedLogo = ''
    },
    cancelCropModalBg() {
      this.showBackground = false
    },
    saveCroppedImageLogo() {
      new fabric.Image.fromURL(this.croppieImageLogo, (img) => {
        // add background image
        this.img = img
        this.canvas.add(this.img)
        this.canvas.centerObject(this.img)
        this.canvas.renderAll()
        let turtle = this.canvas.item(0)
        turtle.bringToFront()
      },
      {
        borderColor:"#23B6BB",
        borderScaleFactor: 3,
        borderOpacityWhenMoving: 1,
        cornerColor: "#D9C731",
        cornerStrokeColor: "#D9C731",
        transparentCorners: false,
        cornerStyle:'circle',
        cornerSize: 20,
      })
      this.cancelCropModal()
    },
    saveCroppedImageBg(cancelCropModal=true) {
      new fabric.Image.fromURL(this.croppieImageBg, (img) => {
        this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas), {
          scaleX: this.canvas.width / img.width,
          scaleY: this.canvas.height / img.height
        })
        this.canvas.renderAll()
        this.canvas._historySaveAction()
        if (cancelCropModal) {
            this.cancelCropModalBg()
        }
      })
    },
    addTurtleLogo() {
      if (!this.editorConfig.has_turtle_logo) {
        return
      }
      // check first if there is not a turtle logo already present
      let turtleExist = false
      let objects = this.canvas.getObjects()

      objects.forEach(function(item) {
        if (item.id == 'turtle') {
          turtleExist = true
        }
      });

      if (!turtleExist) {
        this.croppieImageLogo = turtle
        new fabric.Image.fromURL(this.croppieImageLogo, (img) => {
              this.img = img
              this.canvas.add(this.img)
              this.img.bringToFront()
              this.img.bringForward()
            },
            {
              id: 'turtle',
              hasControls: true,
              hasBorders: true,
              selection: true,
              lockMovementX: false,
              lockMovementY: false,
              left: this.canvas.width - 400,
              top: this.canvas.height - 203,
              lockScalingX: true,
              lockScalingY: true,
              selectable: true,
              absolutePositioned: true
            })
        this.croppieImageLogo = ''
      }
    },
    croppieLogo(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let reader = new FileReader()
      reader.onload = e => {
        this.$refs.croppieRefLogo.bind({
          url: e.target.result
        })
      }
      reader.readAsDataURL(files[0])
      this.showLogo = true
      e.target.value = null
    },
    croppieBg(e) {
      this.$refs.imageModal.answerNAY()
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let reader = new FileReader()
      reader.onload = e => {
        this.$refs.croppieRefBg.bind({
          url: e.target.result
        })
      }
      reader.readAsDataURL(files[0])
      this.showBackground = true
      e.target.value = null
    },
    selectImage(image) {
      this.$refs.imageModal.answerNAY()
      this.$refs.croppieRefBg.bind({
        url: image.image
      })
      this.showBackground = true
    },
    changeCropperLogo() {
      let options = {
        type: 'base64',
        size: "original",
        quality: 1,
        format: 'png'
      };
      this.$refs.croppieRefLogo.result(options, output => {
        this.croppedLogo = this.croppieImageLogo = output
      })
    },
    changeCropperBg() {
      let options = {
        type: 'base64',
        size: "original",
        quality: 1,
        format: 'png'
      }
      this.$refs.croppieRefBg.result(options, output => {
        if (this.isMultiSided) {
          this.sideCroppedBgs[this.activeSideName] = output
          this.croppieImageBg = output
        } else {
          this.croppedBg = this.croppieImageBg = output
        }
        this.croppieDataBg = this.$refs.croppieRefBg.get()
      })
    },
    rotateLogo() {
      this.$refs.croppieRefLogo.rotate(90)
    },
    rotateBg() {
      this.$refs.croppieRefBg.rotate(90)
      this.changeCropperBg()
    },
    checkBoundingBox(e) {
      const obj = e.target

      if (!obj) {
        return
      }
      obj.setCoords()

      const objBoundingBox = obj.getBoundingRect()
      if (objBoundingBox.top < 10) {
        obj.set('top', 10)
        obj.setCoords()
      }
      if (objBoundingBox.left > this.canvas.width - objBoundingBox.width - 50) {
        obj.set('left', this.canvas.width - objBoundingBox.width - 50)
        obj.setCoords()
      }
      if (objBoundingBox.top > this.canvas.height - objBoundingBox.height - 10) {
        obj.set('top', this.canvas.height - objBoundingBox.height - 10)
        obj.setCoords()
      }
      if (objBoundingBox.left < 10) {
        obj.set('left', 10)
        obj.setCoords()
      }
    },
    moveHandler(e) {
      this.checkBoundingBox(e)
    },
    rotating(e) {
      this.checkBoundingBox(e)
    },
    scaling(e) {
      this.checkBoundingBox(e)
    },
    openTab(elemId, tabName) {
      let i, x, tablinks
      x = document.getElementsByClassName("content-tab")
      for (i = 0; i < x.length; i++) {
        x[i].style.display = "none"
      }
      tablinks = document.getElementsByClassName("tab")
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" is-active", "")
      }
      document.getElementById(tabName).style.display = "flex"
      document.getElementById(elemId).className += " is-active"
    },
    sideWrapperStyle(side) {
      const bleedMm = this.editorConfig.bleed_mm || 0
      let bx = 0, by = 0
      if (bleedMm && side.width_mm && side.height_mm) {
        bx = Math.round(bleedMm * side.width / side.width_mm)
        by = Math.round(bleedMm * side.height / side.height_mm)
      }
      return {
        height: (side.height + by * 2) + 'px',
        width: (side.width + bx * 2) + 'px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }
    },
    openEditableTab(sideName) {
      this.activeSideName = sideName
      const side = this.editorConfig.sides.find(s => s.name === sideName)
      if (side) {
        this.canvas = this.sideCanvases[sideName]
        const bleedMm = this.editorConfig.bleed_mm || 0
        let bleedPxX = 0, bleedPxY = 0
        if (bleedMm && side.width_mm && side.height_mm) {
          bleedPxX = Math.round(bleedMm * side.width / side.width_mm)
          bleedPxY = Math.round(bleedMm * side.height / side.height_mm)
        }
        this.canvasWidth = side.width + bleedPxX * 2
        this.canvasHeight = side.height + bleedPxY * 2
      }
    },
    open3DPreview() {
      this.canvas.discardActiveObject()
      this.removeGrid()
      this.canvas.renderAll()

      if (this.isMultiSided) {
        this._hideBleedGuides()
        for (const side of this.editorConfig.sides) {
          let canvasEl = document.getElementById(side.canvasId)
          this.sideDataUrls[side.name] = canvasEl.toDataURL()
        }
        this._showBleedGuides()
      } else {
        let canvas = document.getElementById('editorcanvas')
        this.dataUrl = canvas.toDataURL()
      }
      this.$refs.previewModal.showModal()
    },
    openFontModal() {
      this.$refs.fontModal.showModal()
    },
    openBankImageModal() {
      this.$refs.imageModal.showModal()
    },
    openHelpModal() {
      this.$refs.editorHelpModal.showModal();
    },
    deleteBackgroundPicture() {
      this.canvas.setBackgroundImage(null, this.canvas.renderAll.bind(this.canvas))
      this.croppedBg = ''
    },
    addCircle() {
      this.circle = new fabric.Circle({
        radius: 50,
        fill: 'transparent',
        left: 100,
        top: 100,
        borderColor: "#23B6BB",
        borderScaleFactor: 3,
        borderOpacityWhenMoving: 1,
        cornerColor: "#D9C731",
        cornerStrokeColor: "#D9C731",
        transparentCorners: false,
        cornerStyle: 'circle',
        cornerSize: 20,
        hasBorders: true,
        hasControls: true,
        stroke: this.shapeColor,
        strokeWidth: 7
      })

      this.canvas.add(this.circle)
      let turtle = this.canvas.item(0)
      turtle.bringToFront()
    },
    addRectangle() {
      this.rectangle = new fabric.Rect({
        width: 100,
        height: 100,
        left: 100,
        top: 100,
        stroke: this.shapeColor,
        strokeWidth: 7,
        fill: 'transparent',
        cornerColor: "#D9C731",
        cornerStrokeColor: "#D9C731",
        transparentCorners: false,
        cornerStyle: 'circle',
        cornerSize: 20,
      })
      this.canvas.add(this.rectangle)
      let turtle = this.canvas.item(0)
      turtle.bringToFront()
    },
    openTurtleModal() {
      this.setNotificationActiveState({
        'notificationState': true,
        'message': this.$t("message.components.addProduct.modalText")
      })      
    }    
  },
  computed: {
    logoCroppieBoundary() {
      const maxW = Math.min(450, window.innerWidth - 60)
      return { width: maxW, height: maxW * (300 / 450) }
    },
    logoCroppieViewport() {
      const maxW = Math.min(200, window.innerWidth - 100)
      return { width: maxW, height: maxW / 2, type: 'square' }
    },
    bleedConfig() {
      // Returns { bleed_mm, px_per_mm_x, px_per_mm_y, bleed_px_x, bleed_px_y } for current side
      const bleedMm = this.editorConfig.bleed_mm || 0
      if (!bleedMm) return null
      const side = this.editorConfig.sides?.find(s => s.name === this.activeSideName)
      if (!side || !side.width_mm || !side.height_mm) return null
      const pxPerMmX = side.width / side.width_mm
      const pxPerMmY = side.height / side.height_mm
      return {
        bleed_mm: bleedMm,
        bleed_px_x: Math.round(bleedMm * pxPerMmX),
        bleed_px_y: Math.round(bleedMm * pxPerMmY),
      }
    },
    bgCroppieBoundary() {
      const totalW = this.canvasWidth + (this.bleedConfig ? this.bleedConfig.bleed_px_x * 2 : 0)
      const totalH = this.canvasHeight + (this.bleedConfig ? this.bleedConfig.bleed_px_y * 2 : 0)
      const w = Math.min(totalW / 4.2, window.innerWidth - 60)
      const ratio = totalH / totalW
      return { width: w + 40, height: w * ratio + 40 }
    },
    bgCroppieViewport() {
      const totalW = this.canvasWidth + (this.bleedConfig ? this.bleedConfig.bleed_px_x * 2 : 0)
      const totalH = this.canvasHeight + (this.bleedConfig ? this.bleedConfig.bleed_px_y * 2 : 0)
      const w = Math.min(totalW / 4.2, window.innerWidth - 60)
      const ratio = totalH / totalW
      return { width: w, height: w * ratio, type: 'square' }
    },
    croppieBleedOverlayStyle() {
      // CSS style for the inner "safe zone" rectangle drawn on top of the croppie viewport
      if (!this.bleedConfig) return null
      const totalW = this.canvasWidth + this.bleedConfig.bleed_px_x * 2
      const totalH = this.canvasHeight + this.bleedConfig.bleed_px_y * 2
      const viewportW = Math.min(totalW / 4.2, window.innerWidth - 60)
      const scale = viewportW / totalW
      const borderX = Math.round(this.bleedConfig.bleed_px_x * scale)
      const borderY = Math.round(this.bleedConfig.bleed_px_y * scale)
      return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: `${viewportW - 2 * borderX}px`,
        height: `${viewportW * (totalH / totalW) - 2 * borderY}px`,
        transform: 'translate(-50%, -50%)',
        border: '2px dashed rgba(255, 0, 0, 0.7)',
        pointerEvents: 'none',
        zIndex: 1,
        boxSizing: 'border-box',
      }
    },
    editorWrapperStyle() {
      return {
        'transform': `scale(${this.scale})`
      }
    },
    editorHeightProperty() {
      return {
        'height': `${10 + (this.canvasHeight * this.scale)}px !important`
      }
    },
    texture() {
      return [{
        dataUrl: this.dataUrl,
        posx: 0,
        posy: 0,
        width: 1000,
        height: 400,
        rotate: 0
      }]
    },
    editorConfig() {
      const conf = this.product.convert_conf
      if (conf && conf.editor) {
        return conf.editor
      }
      // Fallback for products without editor config
      return {
        sides: [{ name: 'main', ref: 'can', canvasId: 'editorcanvas', width: conf?.width, height: conf?.height }],
        viewer: 'cup',
        has_grid: true,
        has_turtle_logo: true,
      }
    },
    isMultiSided() {
      return this.editorConfig.sides.length > 1
    },
    candyboxViewerTextures() {
      if (!this.isMultiSided) return []
      const sides = this.editorConfig.sides
      const bleedMm = this.editorConfig.bleed_mm || 0
      const textures = sides.map(side => {
        let bx = 0, by = 0
        if (bleedMm && side.width_mm && side.height_mm) {
          bx = Math.round(bleedMm * side.width / side.width_mm)
          by = Math.round(bleedMm * side.height / side.height_mm)
        }
        return {
          gblVariable: side.glb_variable,
          texture: {
            dataUrl: this.sideDataUrls[side.name] || '',
            posx: 0,
            posy: 0,
            width: side.width + bx * 2,
            height: side.height + by * 2,
            rotate: side.texture_rotate || 0
          }
        }
      })
      // Add fixed bottom texture if configured
      if (this.editorConfig.fixed_bottom_texture) {
        textures.push({
          gblVariable: 'Bottom',
          texture: {
            dataUrl: `${process.env.BASE_URL}${this.editorConfig.fixed_bottom_texture}`,
            posx: 0,
            posy: 0,
            width: 555,
            height: 177,
            rotate: 0
          }
        })
      }
      return textures
    },
    textureUri() {
      let path = ''
      if(this.product.name.includes('(6 oz)')) {
        path = `${process.env.BASE_URL}3d/paper-cup-6oz-v5.glb`
      }
      if(this.product.name.includes('(8 oz)')){
        path = `${process.env.BASE_URL}3d/paper-cup-8oz-v5.glb`
      }
      if(this.product.name.includes('(12 oz)')){
        path =  `${process.env.BASE_URL}3d/paper-cup-12oz-v4.glb`
      }
      if(this.product.name.includes('(16 oz)')){
        path =  `${process.env.BASE_URL}3d/paper-cups-16oz-v1.glb`
      }
      if(this.product.name.includes('(20 oz)')) {
        path =  `${process.env.BASE_URL}3d/paper-cup-20oz-v5.glb`
      }
      return path;
    },
    textureUriCandyBox() {
      if (this.editorConfig.glb_path) {
        return `${process.env.BASE_URL}${this.editorConfig.glb_path}`
      }
      return `${process.env.BASE_URL}3d/candybox_uvreset.glb`
    },
    hasBackgroundPicture() {
      if (this.canvas != null && this.canvas.backgroundImage != null) {
        return true
      }
      return false
    },
    shapeColor() {
      let rgb = convert.cmyk.rgb([
          parseInt(this.shapeColorCMYK.cyan),
          parseInt(this.shapeColorCMYK.magenta),
          parseInt(this.shapeColorCMYK.yellow),
          parseInt(this.shapeColorCMYK.black)
        ]
      )
      const hex = convert.rgb.hex(rgb);
      return '#' + hex
    },
    fontColor() {
      let rgb = convert.cmyk.rgb([
          parseInt(this.fontColorCMYK.cyan),
          parseInt(this.fontColorCMYK.magenta),
          parseInt(this.fontColorCMYK.yellow),
          parseInt(this.fontColorCMYK.black)
        ]
      )
      const hex = convert.rgb.hex(rgb);
      return '#' + hex
    },
    backgroundColor() {
      let rgb = convert.cmyk.rgb([
          parseInt(this.backgroundColorCMYK.cyan),
          parseInt(this.backgroundColorCMYK.magenta),
          parseInt(this.backgroundColorCMYK.yellow),
          parseInt(this.backgroundColorCMYK.black)
        ]
      )
      const hex = convert.rgb.hex(rgb);
      return '#' + hex
    },
  }
}
</script>
<style lang="scss" scoped>
@use '../assets/sass/variables' as *;
@import url('vue-accessible-color-picker/styles');

canvas {
  border-bottom: 0px solid lightgray;
  border-left: 0px solid lightgray;
  border-right: 0px solid lightgray;
  width: 100%;
  margin-top: 0;
  cursor: default;
}

.editor-wrapper {
  transform-origin: top left;
}

h2 {
  font-family: Ubuntu, Helvetica, sans-serif;
  text-align: center;
}

.button {
  display: flex;
  justify-content: center;
  background-color: #333;
  border: 1px solid grey;
  padding: 2px 10px;
  text-transform: uppercase;
  color: white;
  width: 37px;
  height: 37px;
  margin-top: 0px;
  cursor: pointer;
}

.button:hover,
.button:focus {
  border-color: white;
  outline: none;
}

input[type="file"] {
  display: none;
}

body {
  font-family: Ubuntu, Helvetica, sans-serif;
}

.d-color {
  color: $pyroll-violet !important;
}

.tab:first-child {
  border-left: 0px;
  .editor-text-icon {
    border-left: 0px;
  }
}

.tab:last-child {
  border-right: 0px;
  .editor-text-icon {
    border-right: 0px;
  }
}

.tab {
  background-color: #F0EFE477;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.tab.is-active {
  border-bottom: 0px;
  .editor-text-icon {
    svg {
      color: $pyroll-violet;
    }
    .editor-action-text {
      color: $pyroll-violet;
    }
  }
}

.tab .editor-text-icon {
  svg {
    color: $font-color-primary;
    font-size: 35px;
    margin-top: 15px;
  }
  .editor-action-text {
    color: $font-color-primary;
    font-size: 15px;
    font-family: Ubuntu;
    margin-top: 20px;
  }
}

.editor-text-icon {
  svg {
    color: $pyroll-violet;
    font-size: 35px;
    margin-top: 15px;
  }
  .editor-action-text {
    color: $pyroll-violet;
    font-size: 15px;
    font-family: Ubuntu;
    margin-top: 20px;
  }
}

.editor-text-icon-modal {
  svg {
    color: $pyroll-violet;
    font-size: 35px;
    margin-top: 15px;
  }
  .editor-action-text {
    color: $pyroll-violet;
    font-size: 15px;
    font-family: Ubuntu;
    margin-left: 30px;
    position: relative;
    top: -10px;
  }
}

.default-active {
  display: flex;
}

.border-bottom {
  border-bottom: 1px solid #707070;
}

.top-editor-controls {
  svg {
    color: $pyroll-violet;
    font-size: 25px;
  }
  .top-editor-text {
    font-size: 16px;
    font-family: Ubuntu;
    margin-top: 7px;
    color: $pyroll-violet;
  }
}

.editor-wrapper canvas {
  border: 2px solid #707070;
}

.is-bordered {
  border: 1px solid #161637;
}

// font dropdown

.fontDropdown {
  position: relative;
  display: inline-block;
}

.font-dropdown-content {
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  overflow: auto;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.font-dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.fontDropdown a:hover {background-color: #ddd;}

.bg-color-picker-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border: 1px solid gray;
  background-color: white;
  z-index: 100;
}

.icon-disabled {
  cursor: not-allowed !important;
  svg {
    color: #dddddd;
  }
}

.text-disabled {
  color: #dddddd !important;
}

.fontSelector {
  text-align: center;
  a {
    color: black;
    width: 150px;
    display: inline-block;
  }
  a:hover {
    border: 1px solid $pyroll-violet
  }
  a.selected {
    border: 3px solid $pyroll-violet
  }
}

p {
  text-align: center;
  font-family: Ubuntu;
  font-size: 20px;
}

.imageSelector {
  overflow-y: scroll;
  max-height: 300px;

  img:hover {
    cursor: pointer;
    border: 1px solid $pyroll-violet;
  }
}

#color-preview {
  width: 100px;
  height: 100px;
  border: 1px solid #000;
}

.horizontal-image-selector-tab {
  display: flex;
  list-style: none;
  gap: 10px;
  padding: 0;
  margin: 0;
  li.is-active {
    color: $pyroll-violet;
  }
  li:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.bleed-label {
  margin-top: 4px;
  color: #cc0000;
  font-size: 12px;
}

</style>
